package org.example.project.ui.components

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import org.example.project.client.model.ActivityStatus
import org.example.project.ui.theme.EditorColors

@Composable
fun StatusBadge(
    status: ActivityStatus,
    modifier: Modifier = Modifier
) {
    val isDraft = status == ActivityStatus.DRAFT
    val bgColor = if (isDraft) EditorColors.DraftBg else EditorColors.SuccessBg
    val textColor = if (isDraft) EditorColors.DraftText else EditorColors.SuccessText
    val borderColor = if (isDraft) EditorColors.DraftBorder else EditorColors.SuccessBorder
    val label = if (isDraft) "SZKIC" else "OPUBLIKOWANA"

    Surface(
        shape = RoundedCornerShape(999.dp),
        color = bgColor,
        border = BorderStroke(1.dp, borderColor),
        modifier = modifier
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier.padding(horizontal = 10.dp, vertical = 3.dp)
        ) {
            Text(
                text = label,
                color = textColor,
                fontSize = 10.sp,
                fontWeight = FontWeight.Bold,
                letterSpacing = 0.5.sp
            )
        }
    }
}

@Composable
fun MetadataTag(
    label: String,
    value: String,
    modifier: Modifier = Modifier
) {
    Surface(
        shape = RoundedCornerShape(999.dp),
        color = EditorColors.SurfaceSubtle,
        border = BorderStroke(1.dp, EditorColors.BorderSubtle),
        modifier = modifier
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier.padding(horizontal = 10.dp, vertical = 4.dp)
        ) {
            Text(
                text = "$label: ",
                color = EditorColors.TextMuted,
                fontSize = 11.sp,
                fontWeight = FontWeight.Normal
            )
            Text(
                text = value,
                color = EditorColors.TextPrimary,
                fontSize = 11.sp,
                fontWeight = FontWeight.SemiBold
            )
        }
    }
}

@Composable
fun FilterChip(
    label: String,
    selected: Boolean,
    onClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    val bgColor = if (selected) EditorColors.Primary else EditorColors.Surface
    val textColor = if (selected) EditorColors.Surface else EditorColors.TextSecondary
    val borderColor = if (selected) EditorColors.Primary else EditorColors.Border

    Surface(
        shape = RoundedCornerShape(999.dp),
        color = bgColor,
        border = BorderStroke(1.dp, borderColor),
        modifier = modifier.clickable { onClick() }
    ) {
        Text(
            text = label,
            color = textColor,
            fontSize = 12.sp,
            fontWeight = if (selected) FontWeight.SemiBold else FontWeight.Medium,
            modifier = Modifier.padding(horizontal = 14.dp, vertical = 6.dp)
        )
    }
}
